import fetch from "@/utils/request";


export default {
  modifyLoginPassword(data?: object): any {
    return fetch({
      url: "/php/api/auth/modify_password",
      method: "post",
      data
    });
  },

  modifyTradePassword(data?: object): any {
    return fetch({
      url: "/php/api/account/modify/password",
      method: "post",
      data
    });
  },

  verifyIdCard(data?: object): any {
    return fetch({
      url: "/php/api/account/check/card",
      method: "post",
      data
    });
  },

  resetTradePassword(data?: object): any {
    return fetch({
      url: "/php/api/account/reset/password",
      method: "post",
      data
    });
  },

  loginDeviceList(data?: object): any {
    return fetch({
      url: "/php/api/user/plate_list",
      method: "get",
      data
    });
  },

  deleteDevice(data?: object): any {
    return fetch({
      url: "/php/api/user/plate_del",
      method: "post",
      data
    });
  }
};
